@if (isAuthenticated) {
  <app-nav-menu/>
}
@if (headerData().visible && !(isExpandedWideRoute$ | async) && isAuthenticated) {
  <app-header [headerData]="headerData()"/>
}
@if (isAuthenticated || (isGuestUser$ | async)) {
  <div
    class="content-container"
    [class]="{
      collapsed: collapsedMenu(),
      expanded: !collapsedMenu(),
      'document-page': (isExpandedWideRoute$ | async),
      'main-page': !(isExpandedWideRoute$ | async),
    }"
  >
    <div [class]="((isExpandedWideRoute$ | async) ? 'content-document-wrapper' : 'content-wrapper')">
      <router-outlet/>
    </div>
  </div>
}
@if (!isAuthenticated && !(isGuestUser$ | async)) {
  <app-loader minHeight="full"/>
}
